// PATH: src/pages/HomePage.tsx
// Page de vérification Phase 0 : état du backend (healthcheck) et de la session SSO.
import React, { useEffect, useState } from "react";
import { Card, Descriptions, Layout, Tag, Typography } from "antd";
import { useApiClient } from "../api/apiClients";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

interface MeResponse {
  auth_mode: string;
  user_id?: number;
  organization_id?: number;
  user_type_code?: string;
  roles?: string[];
}

const HomePage: React.FC = () => {
  const api = useApiClient("tilmischool");
  const [health, setHealth] = useState<"pending" | "ok" | "ko">("pending");
  const [me, setMe] = useState<MeResponse | null>(null);
  const [meError, setMeError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get("/health")
      .then(() => setHealth("ok"))
      .catch(() => setHealth("ko"));

    api
      .get<MeResponse>("/api/v1/me")
      .then((res) => setMe(res.data))
      .catch((err) => {
        if (err?.response?.status === 401) {
          setMeError("Non authentifié — connectez-vous via tc_identity (cookie tc_session).");
        } else {
          setMeError("Backend injoignable.");
        }
      });
  }, [api]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header>
        <Title level={3} style={{ color: "white", margin: "12px 0" }}>
          TilmiSchool
        </Title>
      </Header>
      <Content style={{ padding: 24, maxWidth: 720, margin: "0 auto", width: "100%" }}>
        <Card title="État du service (Phase 0)" style={{ marginBottom: 16 }}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Backend tc_tilmischool_be">
              {health === "pending" && <Tag>Vérification…</Tag>}
              {health === "ok" && <Tag color="green">OK</Tag>}
              {health === "ko" && <Tag color="red">Injoignable</Tag>}
            </Descriptions.Item>
            <Descriptions.Item label="Session SSO (tc_identity)">
              {me && (
                <>
                  <Tag color="green">Authentifié</Tag>
                  <Text>
                    user_id={me.user_id} · organisation={me.organization_id} ·{" "}
                    {me.user_type_code} · rôles: {(me.roles || []).join(", ") || "—"}
                  </Text>
                </>
              )}
              {!me && meError && <Tag color="orange">{meError}</Tag>}
              {!me && !meError && <Tag>Vérification…</Tag>}
            </Descriptions.Item>
          </Descriptions>
        </Card>
        <Text type="secondary">
          Squelette Phase 0 — les modules métier (élèves, pédagogie, paiements,
          personnel) arrivent dans les phases suivantes.
        </Text>
      </Content>
    </Layout>
  );
};

export default HomePage;
